// test34
(34 && 0);
